/**
 * File stats-collapsible.js.
 * Handles toggling stats.
 */

const collapsibleStats = document.querySelectorAll('.stats-collapsible__stat-toggle');
const collapsibleStatsActiveClass = 'stats-collapsible__stat--active';

function toggleStat() {
  // close any open stats
  for (let i = 0; i < collapsibleStats.length; i++) {
    if (collapsibleStats[i] !== this) {
      collapsibleStats[i].parentElement.classList.remove(collapsibleStatsActiveClass);
    }
  }

  // toggle the clicked stat
  this.parentElement.classList.toggle(collapsibleStatsActiveClass);
}

for (let i = 0; i < collapsibleStats.length; i++) {
  collapsibleStats[i].addEventListener('click', toggleStat);
}
